import type { Nullable } from '@libs/core';
import type { StoreV2 } from '@libs/common-types';
import { NAVIGATION_URLS } from '@libs/core';
import { getStoreDetailsPathname } from '@libs/common-next';
import type { CategoryTypes } from '../types';

export const handleNavLink = (type: CategoryTypes['type'], text?: string, href?: string, store?: Nullable<StoreV2>) => {
    const isMyStore = type === 'my-store';
    const isStoreEmpty = isMyStore && !store?.StoreNumber;
    switch (true) {
        case isStoreEmpty:
            return {
                href: NAVIGATION_URLS.legacy.storeLocator.base,
                text,
            };
        case isMyStore && !!store:
            return {
                href: getStoreDetailsPathname(store as StoreV2),
                text,
            };
        case type !== 'card':
            return { href, text };
        default:
            return { href: undefined, text };
    }
};
